import React, { useEffect, useMemo, useState } from 'react'
import type { Contact } from 'types/list'
import type { State } from 'types/redux'
import DataTable from 'components/ui/data-table'
import Spinner from 'components/ui/spinner'
import ContactCard from '../contact-card'
import { useDispatch } from 'react-redux'
import { loadContactEmailGroups } from '@disco/state-management/actions/EmailGroupActions'

import { useSelector } from 'react-redux'
type Props = {
  emailGroups: State['emailGroups']
  contact: Contact
  listFormStartManagingLists: (...args: Array<any>) => any
}

const ListsTab: React.FC<Props> = ({
  emailGroups,
  contact,
  listFormStartManagingLists,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()
  const { contactEmailGroups, error, contactEmailGroupsFetched } = emailGroups

  useEffect(() => {
    if (contact.id) {
      dispatch(loadContactEmailGroups(contact.id))
    }
  }, [contact.id])

  useEffect(() => {
    if (contactEmailGroups?.length && contactEmailGroupsFetched) {
      setIsLoading(false)
    }
  }, [contactEmailGroups, contactEmailGroupsFetched])

  const matchingLists = useMemo(() => {
    if (!contactEmailGroups) return
    setIsLoading(false)
    return contactEmailGroups
  }, [contactEmailGroups])

  const renderContent = () => {
    if (isLoading) {
      return <Spinner />
    }

    if (error) {
      return error.toString()
    }
    if (matchingLists?.length) {
      return (
        <DataTable
          columns={[
            {
              id: 'name',
            },
            {
              width: 'content',
              render: (props: Record<string, any>) => (
                <DataTable.Link to={`/lists/${props.id}`}>
                  View mailing list
                </DataTable.Link>
              ),
            },
          ]}
          data={matchingLists}
          rows={matchingLists?.length}
        />
      )
    }
  }

  return (
    <ContactCard
      title={
        !contact.email
          ? 'Contact without email could not be added to list'
          : 'To add this contact to a mailing list, click ‘Manage mailing lists’'
      }
      action={{
        content: 'Manage mailing lists',
        disabled: !contact.email,
        onClick: () => listFormStartManagingLists([contact], 'MULTIPLE_LISTS'),
      }}
    >
      {renderContent()}
    </ContactCard>
  )
}

export default ListsTab
